<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <h3>Mis beneficios</h3>
        <p>
          Consulta los beneficios que tienes como miembro / afiliado de la
          organización.
        </p>
      </v-col>
      <v-col
        :cols="
          $vuetify.breakpoint.smAndDown
            ? 12
            : $vuetify.breakpoint.lgAndDown
            ? 12
            : 4
        "
        v-if="showMicaBenefit"
      >
        <benefitsCard
          name="MICA"
          description="Protección de Renta
            Protección legal con arbitraje y respaldo financiero ante retrasos o impago de renta. Recibe 20% de comisión.
            Investigación de inquilino
            50% de descuento. Evaluación de identidad, historial laboral, crediticio, salud financiera y antecedentes legales. Resultados en horas."
          icon="https://wechamber-v3-files-prod-2.s3.us-east-2.amazonaws.com/sponsor/mica.png"
          :api="handleMicaBenefits"
          benefitType="api"
        >
        </benefitsCard>
      </v-col>
      <v-col
        :cols="
          $vuetify.breakpoint.smAndDown
            ? 12
            : $vuetify.breakpoint.lgAndDown
            ? 12
            : 4
        "
        v-for="(item, i) in benefitsList"
        :key="i"
      >
        <benefitsCard
          :name="item.name"
          :description="item.description"
          :icon="item.icon"
          :url="item.url"
        />
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import benefitsCard from '@/components/dashboard/Benefits/benefitsCard';
import { mapActions, mapState } from 'vuex/dist/vuex.common.js';
import { isOrganization } from "@/share/validateOrganization";

export default {
  components: {
    benefitsCard,
  },
  data() {
    return {
      benefitsList: [],
    };
  },
  created() {
    this.getAllBenefits();
  },
  computed: {
    ...mapState('user', ['user']),
    showMicaBenefit() {
      return this.benefitsList?.length > 0 && isOrganization('ampi', this.user?._id, this.user?.headOffice?._id)
    }
  },
  methods: {
    ...mapActions('benefits', ['getUserBenefits']),
    isOrganization,
    async getAllBenefits() {
      try {
        let response = await this.getUserBenefits();
        this.benefitsList = response.data.benefits;
      } catch (error) {
        console.log(error);
      }
    },

    async handleMicaBenefits(){
      try {
        const response = await this.axios.get('/users/ampi/benefits/mica');

        if (response?.data)  
          window.open(response.data.url, '_blank');
      
      } catch (error) {
        console.log(error)
      }
    }
  },
};
</script>
